export default "__VITE_ASSET__b292290b__"